module.exports = __webpack_public_path__ + "static/media/image (53).043f598a.jpg";